import { render, staticRenderFns } from "./Colleges.vue?vue&type=template&id=80972498&scoped=true"
import script from "./Colleges.vue?vue&type=script&lang=js"
export * from "./Colleges.vue?vue&type=script&lang=js"
import style0 from "./Colleges.vue?vue&type=style&index=0&id=80972498&prod&lang=scss"
import style1 from "./Colleges.vue?vue&type=style&index=1&id=80972498&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80972498",
  null
  
)

export default component.exports